var map = {
	"./assets-hhl/img/index/wapRectangle 247@2x.png": "4f5b",
	"./assets-mc/img/index/wapRectangle 247@2x.png": "7401",
	"./img/index/wapRectangle 247@2x.png": "c0f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c9ca";